import {LinkContainer} from './elements';

export const Link = ({...properties}) => <LinkContainer {...properties} />;
